import { Route, Routes } from 'react-router-dom'
import FinalizedReportPdf from './FinalizedReportPdf'
import MesIntegrationReportPdf from './MesIntegrationReportPdf'

export default function PdfReports() {
  return (
    <Routes>
      <Route path="finalized/:id" element={<FinalizedReportPdf />} />
      <Route path="mes-integration/:id" element={<MesIntegrationReportPdf />} />
    </Routes>
  )
}
